import React, { useMemo } from 'react';
import { styled } from 'baseui';
import { KIND as NOTIFICATION_KIND, Notification } from 'baseui/notification';
import { isChromeBrowser } from './utils/browser';
import { BANNER_TEXT } from './browser-recommendation-text';
const StyledWrapper = styled('div', ({
  $theme
}) => ({
  padding: $theme.sizing.scale200,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  width: '100%',
  boxSizing: 'border-box',
  overflowX: 'hidden',
  flex: '0 0 auto'
}));
const BannerContent = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale300
}));
const BrowserRecommendationBanner = () => {
  const isChrome = useMemo(() => isChromeBrowser(), []);
  if (isChrome) return null;
  return <StyledWrapper>
      <Notification overrides={{
      Body: {
        style: ({
          $theme
        }) => ({
          maxWidth: '100%',
          width: 'auto',
          boxSizing: 'border-box',
          overflow: 'hidden',
          marginTop: 0,
          marginBottom: 0,
          paddingRight: $theme.sizing.scale800
        })
      },
      CloseIcon: {
        style: ({
          $theme
        }) => ({
          top: $theme.sizing.scale200,
          right: $theme.sizing.scale200
        })
      }
    }} kind={NOTIFICATION_KIND.warning} closeable>
        <BannerContent>{BANNER_TEXT}</BannerContent>
      </Notification>
    </StyledWrapper>;
};
export default BrowserRecommendationBanner;